var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaultThemeInvariants = {
    typography: {
        h6: {
            fontWeight: 400,
        },
    },
    sidebar: {
        width: 240,
        closedWidth: 50,
    },
    components: {
        MuiAutocomplete: {
            variants: [
                {
                    props: {},
                    style: function (_a) {
                        var _b;
                        var theme = _a.theme;
                        return (_b = {},
                            _b[theme.breakpoints.down('sm')] = { width: '100%' },
                            _b);
                    },
                },
            ],
        },
        MuiTextField: {
            defaultProps: {
                variant: 'filled',
                margin: 'dense',
                size: 'small',
            },
            variants: [
                {
                    props: {},
                    style: function (_a) {
                        var _b;
                        var theme = _a.theme;
                        return (_b = {},
                            _b[theme.breakpoints.down('sm')] = { width: '100%' },
                            _b);
                    },
                },
            ],
        },
        MuiFormControl: {
            defaultProps: {
                variant: 'filled',
                margin: 'dense',
                size: 'small',
            },
        },
    },
};
export var defaultLightTheme = __assign(__assign({ palette: {
        background: {
            default: '#fafafb',
        },
        secondary: {
            light: '#6ec6ff',
            main: '#2196f3',
            dark: '#0069c0',
            contrastText: '#fff',
        },
    } }, defaultThemeInvariants), { components: __assign(__assign({}, defaultThemeInvariants.components), { MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    '&$disabled': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    },
                },
            },
        } }) });
export var defaultDarkTheme = __assign({ palette: {
        mode: 'dark',
        primary: {
            main: '#90caf9',
        },
        background: {
            default: '#313131',
        },
    } }, defaultThemeInvariants);
export var defaultTheme = defaultLightTheme;
//# sourceMappingURL=defaultTheme.js.map